import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PushPortalServiceProvider } from 'services/push-portal.service';
import CQSpinner from 'components/cq-spinner';

/**
 * OAuth callback handler for Push Portal org registration.
 *
 * Exchanges the Salesforce OAuth code for an org record and routes back
 * to the Push Portal landing page on success.
 */
function CQPushPortalCallback() {
    const navigate = useNavigate();
    const [error, setError] = useState('');

    /**
     * Parse callback params and complete OAuth exchange.
     * Shows an error state on missing/failed parameters.
     */
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        const state = params.get('state');
        const sfError = params.get('error');
        const sfErrorDescription = params.get('error_description');

        if (sfError) {
            setError(sfErrorDescription || sfError);
            return;
        }

        if (!code || !state) {
            setError('Missing OAuth code or state parameter.');
            return;
        }

        const createdBy = localStorage.getItem('loggedInUsername') || '';
        if (!createdBy) {
            setError('Could not resolve current user for org registration. Please refresh and try again.');
            return;
        }

        PushPortalServiceProvider.exchangeOAuthCode(code, state, createdBy)
            .then(() => navigate('/push-portal', { replace: true }))
            .catch(err =>{ 
                console.error('this is hte error while exchange oauth code', err);
                setError(err?.response?.data?.error || 'OAuth exchange failed')
            });
    }, []);

    // Show a blocking error banner if OAuth exchange fails.
    if (error) {
        return (
            <div className="slds-p-around_large slds-text-align_center">
                <div className="slds-notify slds-notify_alert slds-alert_error slds-m-bottom_medium" role="alert">
                    <span>{error}</span>
                </div>
                <button className="slds-button slds-button_brand" onClick={() => navigate('/push-portal')}>
                    Back to Push Portal
                </button>
            </div>
        );
    }

    return (
        <div className="slds-p-around_large slds-text-align_center">
            <CQSpinner />
            <p className="slds-text-body_regular slds-m-top_medium">Completing org registration…</p>
        </div>
    );
}

export default CQPushPortalCallback;
